import { Address } from '@/types/entity/address';

// EWM-950 — the single composition rule for the name line on an address.
//
// A delivery address carries the ORGANISATION and nothing else. Reported via
// E3903923 (Higgins): the ordering associate's name was being written into the
// delivery address, so parcels arrived addressed to a person who might not be
// the recipient — or who had left the company.
//
// Deliberately returns `undefined` (not '') when there is no company, so every
// caller can drop the line entirely rather than render a blank or malformed one.
// This reverses the person-fallback that EWM-640 introduced.
export const addressNameLine = (address: Partial<Address>): string | undefined => {
  const company = address.company?.trim();
  if (company) return company;

  // `name` is the derived single-line label. Post-EWM-950 it mirrors `company`,
  // so this only matters for an entity built before the mapper change or by
  // hand — and mapAddress no longer derives it from the person, so it can never
  // reintroduce a contact name here.
  const label = address.name?.trim();
  return label || undefined;
};
